import React, { useEffect, useState } from "react";
import { getOrders, getCustomers } from "../api/api";
import "../styles/Dashboard.css";
import RecentOrders from "./RecentOrders";

const Dashboard = () => {
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOrders();
    fetchCustomers();
  }, []);

  const fetchOrders = async () => {
    try {
      // In admin view, we pass no userId to get all orders.
      const response = await getOrders();
      if (Array.isArray(response.data)) {
        setOrders(response.data);
      } else {
        console.error("Unexpected orders format:", response.data);
        setOrders([]);
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      setError("Error fetching orders");
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await getCustomers();
      if (Array.isArray(response.data)) {
        setCustomers(response.data);
      } else {
        console.error("Unexpected customers format:", response.data);
        setCustomers([]);
      }
    } catch (err) {
      console.error("Error fetching customers:", err);
      setError("Error fetching customers");
    }
  };

  // Helper to check if a date string represents today's date
  const isToday = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()
    );
  };

  // Calculate statistics
  const totalOrders = orders.length;
  const todaysOrders = orders.filter((order) => isToday(order.created_at)).length;
  const deliveredOrders = orders.filter((order) => order.status === "Delivered").length;
  const pendingOrders = orders.filter((order) => order.status === "Pending").length;
  const totalCustomers = customers.length;

  return (
  <div className="dashboard">
    {/* Header */}
    <header className="dashboard-header">
      <h2>Dashboard</h2>
    </header>

    {error && <p className="error">{error}</p>}

    {/* Stats Cards */}
    <div className="dashboard-stats">
      <div className="dashboard-card">
        <div className="card-value">{totalOrders}</div>
        <div className="card-title">Total Orders</div>
      </div>
      <div className="dashboard-card">
        <div className="card-value">{todaysOrders}</div>
        <div className="card-title">Today's Orders</div>
      </div>
      <div className="dashboard-card">
        <div className="card-value">{deliveredOrders}</div>
        <div className="card-title">Delivered Orders</div>
      </div>
      <div className="dashboard-card">
        <div className="card-value">{pendingOrders}</div>
        <div className="card-title">Pending Orders</div>
      </div>
      <div className="dashboard-card">
        <div className="card-value">{totalCustomers}</div>
        <div className="card-title">Total Customers</div>
      </div>
    </div>

    {/* Recent Orders Table */}
    <section className="dashboard-table">
      <RecentOrders />
    </section>
  </div>
);
};

export default Dashboard;
